import * as React from 'react';
import {useEffect, useState} from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import SourceExplorer from '../../components/organisms/sourceExplorer/SourceExplorer';
import TargetExplorer from '../../components/organisms/targetExplorer/TargetExplorer';
import ExtractorExplorer from '../../components/organisms/extractorExplorer/ExtractorExplorer';
import OverRideExplorer from '../../components/organisms/overRideExplorer/OverRideExplorer';
import LoaderExplorer from '../../components/organisms/loaderExplorer/LoaderExplorer';
import SpokeExplorer from '../../components/organisms/spokeExplorer/SpokeExplorer';
import {IProfile} from '../../store/userProfile/types';
import {getProfileSelector} from '../../store/userProfile/selectors';
import {useSelector} from "react-redux";
import {ISpokeDetails} from '../../store/spokes/types';
import {fetchSpokeSelector} from "../../store/spokes/selectors";
import {getRoleClaimsSelector,} from "../../store/auth/selectors";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    label?: String;
    adminOnly?: boolean;
};

const tabs: TabPanelProps[] = [
    {
        index: 0,
        value: 0,
        label: "Data Sources",
    },
    {
        index: 1,
        value: 1,
        label: "Data Extractors",
    },
    {
        index: 2,
        value: 2,
        label: "Data Targets",
    },
    {
        index: 3,
        value: 3,
        label: "Data Loaders",
    },
    {
        index: 4,
        value: 4,
        label: "Spokes",
    },
    {
        index: 5,
        value: 5,
        label: "Overrides",
        adminOnly: true
    },
 
];


const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}


const ResourceExplorer = () => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    const [isAdmin, setIsAdmin] = useState(false);

  //    ************ spoke based access controls ****************
  const userProfile: IProfile[] = useSelector(getProfileSelector);
  const getSpokeList: ISpokeDetails[] = useSelector(fetchSpokeSelector);

  const [spokeProfile, setSpokeProfile] = useState<any>();
  const [spokeList, setSpokeList] = useState<any>();
  const roles = useSelector(getRoleClaimsSelector); // roles  - IDP.Admin or IDP.User

  useEffect(() => {
    if (userProfile && userProfile.length > 0) {
      setSpokeProfile(userProfile);
    }
  }, [userProfile]);

  useEffect(() => {
    if (roles && roles.length > 0) {
      setIsAdmin(roles.includes("IDP.Admin") ? true : false);
    }
  }, [roles]);

  useEffect(() => {
    if (getSpokeList && getSpokeList.length > 0) {
      setSpokeList(getSpokeList);
    }
  }, [getSpokeList]);

//   const checkAdmin = () => {
//     const getSpokeAdmin: any = []
//     spokeList && spokeList.map((x: ISpokeDetails) => {
//       return spokeProfile && spokeProfile.map((y: IProfile) => { return getSpokeAdmin.push(y.adGroupName === x.adminGroupName); })
//     })

//     // check if any value has been returned as true (that means the user is an admin of some spoke), if there is a match (indicated by true) then return regular user as false else display true
//     var array = getSpokeAdmin.every((bool: any) => bool === false);
//     return array

//   }
 //    ************ end spoke based access controls ****************

    return (
        <>
            <h1 style={{ textAlign: "left" }}>Resource Explorer </h1>

            <Box sx={{ width: '100%', background: "#fefefe", borderRadius: "10px" }}>

                <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 1 }}>
                    {/* hide overrides tab if spoke admin */}
                 {isAdmin ?   <Tabs value={value} onChange={handleChange} aria-label="resource explorer">
                        {tabs.map((item) => (
                            <Tab key={item.index} label={item.label} style={{ fontWeight: "bold", padding: "20px 30px" }} />
                        ))}
                    </Tabs> : <Tabs value={value} onChange={handleChange} aria-label="resource explorer">
                        {tabs.filter((x)=> !x.adminOnly).map((item) => (
                            <Tab key={item.index} label={item.label} style={{ fontWeight: "bold", padding: "20px 30px" }} />
                        ))}
                    </Tabs>}
                </Box>

                <TabPanel value={value} index={0}>
                    <SourceExplorer isAdmin={isAdmin} />
                </TabPanel>

                <TabPanel value={value} index={1}>
                    <ExtractorExplorer
                        selectable={"no"}
                        displayIcons={true}
                        displayActionButtons={true}
                        isAdmin={isAdmin}
                    />
                </TabPanel>

                <TabPanel value={value} index={2}>
                    <TargetExplorer isAdmin={isAdmin} />
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <LoaderExplorer
                        selectable={"no"}
                        selectedValue={undefined}
                        isAdmin={isAdmin}
                        displayActionButtons={true}
                    />
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <SpokeExplorer isAdmin={isAdmin} />
                </TabPanel>
                {isAdmin && <TabPanel value={value} index={5}>
                    <OverRideExplorer />
                </TabPanel>}

               

            </Box>
        </>
    );
};

export default ResourceExplorer;